module.exports = __webpack_public_path__ + "static/media/africa_getty_twitter.33537258.jpg";